// Function to generate an array of years, for example, from 1900 to the current year
export const generateYears = (startYear, endYear) => {
	let years = [];
	for (let i = endYear; i >= startYear; i--) {
			years.push({ id: i, name: i.toString() });
	}
	return years;
};
